import { ProviderGoal } from "models/interfaces/providers/provider-goal";
import { Record } from "immutable";
// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: ProviderGoal = {
    year: undefined,
    goalAmount: undefined,
    currentInvoiceTotal: undefined,
    deadline: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class ProviderGoalRecord extends Record(defaultValues) implements ProviderGoal {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<ProviderGoal>) {
        params = params ?? Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    /**
     * Given a set of values for ProviderGoal properties, create a new ProviderGoalRecord object from this
     * instance, overwriting the properties in the values parameter with values provided.
     *
     * @param {Partial<ProviderGoal>} values The values to overwrite on this instance.
     * @returns A ProviderGoalRecord with values from this instance and the values parameter.
     */
    public with(values: Partial<ProviderGoal>): ProviderGoalRecord {
        return new ProviderGoalRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { ProviderGoalRecord };

// #endregion Exports
